import { render, staticRenderFns } from "./ButtonLoader.vue?vue&type=template&id=95de7558&scoped=true"
import script from "./ButtonLoader.vue?vue&type=script&lang=js"
export * from "./ButtonLoader.vue?vue&type=script&lang=js"
import style0 from "./ButtonLoader.vue?vue&type=style&index=0&id=95de7558&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95de7558",
  null
  
)

export default component.exports